<!--
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-09-27 18:40:02
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-09 14:56:33
-->
<template>
    <div>
        <el-form label-position="left" :model="data" class="query-form" size="small" >
            <el-form-item class="query-form-item">
                <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">
                    {{
                        this.list.msgtitle
                    }}
                    <el-button  size="small"  style="width: 80px;position: absolute;right: 20px;" @click.native="goback">返回</el-button>
                </h1>
            </el-form-item>
            <el-form-item class="query-form-item-big">
                {{
                  this.list.msgcontext
                }}
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {
        msgDetails
    } from "@/api/message/message";
    export default {
        data() {
            return {
                loading: false,
                data: {},
                list: [],
                query: {}
            };
        },
        methods: {
          goback() {
                this.$router.go(-1)
            },
            getMsgDetails() {
                msgDetails(this.query)
                    .then(res => {
                      console.log(res)
                        this.list = res.data || [];
                    })
                    .catch(() => {});
            }
        },
        filters: {},
        mounted() {},
        created() {
            this.query.msgId = this.$route.query.msgid;
            this.getMsgDetails();
        }
    };

</script>
<style scoped>
    /deep/ .query-form {
        color: #606266;
        width: 1200px !important;
        border: 1px solid #f4f4f5;
        /* border-bottom: none; */
        margin-bottom: 40px;
        /* border-left: none; */
    }

    .inquiryDetailsTitle {
        line-height: 50px;
        background: #f4f4f5;
        padding-left: 20px;
    }

    /deep/ .query-form-item-big .el-form-item__content {
        padding: 0 20px;
    }

</style>
